import { render, staticRenderFns } from "./Contact1024.vue?vue&type=template&id=a564c8b0&scoped=true"
import script from "./Contact1024.vue?vue&type=script&lang=js"
export * from "./Contact1024.vue?vue&type=script&lang=js"
import style0 from "./Contact1024.vue?vue&type=style&index=0&id=a564c8b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a564c8b0",
  null
  
)

export default component.exports